import { isDefined } from 'utils/tsHelpers';
import { Mapping } from 'api/MappingsAPI';
import { ES_FIELD_UNINDXED_DATA } from 'modules/queryBuilder/constants';
import { GenericDataType } from 'modules/domains';
import { ESTypeMap } from 'modules/workflows/types';

export const getParsedFieldMappings = (mappings: Mapping[]) =>
  mappings.reduce((acc: ESTypeMap, mapping: Mapping) => {
    const { dataType, fieldType, fieldName, isHidden, isAllowed } = mapping;
    // This removal is done for the userMappings endpoint on the BE, but for some reason not applied for all mappings endpoint
    if (
      (dataType === GenericDataType.User && fieldName === ES_FIELD_UNINDXED_DATA) ||
      isHidden ||
      isAllowed === false
    ) {
      return acc;
    }
    return {
      ...acc,
      [dataType]: {
        ...(isDefined(acc[dataType]) && acc[dataType]),
        [fieldName]: { fieldType, field: fieldName },
      },
    };
  }, {});
